<template>
	<div class="submenu-container">
		<span class="mobile-dropdown" :class="{ active }" @click="active = !active" />
		<div class="submenu" :class="{ active: hideAll ? resetState() : active }">
			<ul>
				<li v-for="item in subitems" :key="item.filename">
					<nuxt-link :to="`${item.filename}`" @click="hideMobileNav">
						{{ item.header }}
					</nuxt-link>
				</li>
			</ul>
		</div>
	</div>
</template>

<script setup>
defineProps({
	subitems: { type: Array, default: () => [] },
	hideAll: { type: Boolean, default: false },
});

const emit = defineEmits(['hide-mobile-nav']);

const active = ref(false);

const resetState = () => {
	active.value = false;
};

const hideMobileNav = () => {
	emit('hide-mobile-nav');
};
</script>

<style lang="scss" scoped>
.submenu-container {
	position: relative;
}

a {
	font-weight: 400;
	color: #fff;

	&.active,
	&:hover {
		color: var(--secondary-cta-color);
	}
}

.mobile-dropdown {
	display: none;
	width: 12px;
	height: 8px;
	background: url('~/assets/images/icon-dropdown-white.png') center center no-repeat;
	margin-bottom: 3px;

	&.active {
		transform: rotate(180deg);
	}
}

.submenu {
	ul {
		display: none;
		background: var(--cta-color);
		position: absolute;
		top: 5px;
		left: 0;
		text-align: left;
		padding: 7px;

		&.active {
			display: block;
		}

		li {
			padding: 5px 0;
			list-style: none;

			a {
				margin: 0 10px;
				text-decoration: none;
				font-size: 13px;
				font-weight: 700;
				letter-spacing: 1px;
			}
		}
	}

	&.active ul {
		display: block;
	}
}

@media (max-width: 1200px) {
	.mobile-dropdown {
		display: inline-block;
		margin: 12px 0 0;
	}

	.submenu-container {
		display: inline;
		text-align: center;
		width: auto;
	}

	.submenu {
		width: 100%;

		ul {
			position: static;
			background: transparent;
			text-align: center;
			text-transform: uppercase;
			padding: 15px;
		}
	}
}
</style>
